import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=2552304a&scoped=true&lang=pug&"
import script from "./AppLink.vue?vue&type=script&lang=js&"
export * from "./AppLink.vue?vue&type=script&lang=js&"
import style0 from "./AppLink.vue?vue&type=style&index=0&id=2552304a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2552304a",
  null
  
)

export default component.exports